import LockResetIcon from '@mui/icons-material/LockReset';
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const salesLockRecord = {
    id: 'salesLockRecord',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'salesLockRecord',
            title: 'Sales Lock Record',
            type: 'item',
            url: '/salesLockRecord',
            icon: LockResetIcon,
            breadcrumbs: false,
            
        }
    ]
};

export default salesLockRecord;
